import { SensitiveDataRedactor } from '@arshu/common';
import { JsonUtility } from '../app/jsonUtility.js';
import type { MergeResult } from '../model/mergeResult.js';
import type { TemplateOperation } from '../model/templateOperation.js';

/** Applies the shared sensitive-data policy to every artifact carried by a merge result. */
export class SensitiveArtifactRedactor {
    static redact(result: MergeResult): void {
        result.appFile = SensitiveArtifactRedactor.safe(result.appFile);
        result.resolvedAppSite = SensitiveArtifactRedactor.safe(result.resolvedAppSite);
        result.resolvedAppView = SensitiveArtifactRedactor.safe(result.resolvedAppView);
        result.componentHtml = JsonUtility.redactSensitive(result.componentHtml);
        result.dynamicData = JsonUtility.redactSensitive(result.dynamicData);
        result.dynamicView = JsonUtility.redactSensitive(result.dynamicView);
        result.dynamicAction = JsonUtility.redactSensitive(result.dynamicAction);
        result.dynamicClientData = JsonUtility.redactSensitive(result.dynamicClientData);
        result.dynamicClient = JsonUtility.redactSensitive(result.dynamicClient);
        for (const item of result.navigationTrace) {
            item.handler = SensitiveArtifactRedactor.safe(item.handler); item.fromAppSite = SensitiveArtifactRedactor.safe(item.fromAppSite);
            item.fromAppView = SensitiveArtifactRedactor.safe(item.fromAppView); item.toAppSite = SensitiveArtifactRedactor.safe(item.toAppSite);
            item.toAppView = SensitiveArtifactRedactor.safe(item.toAppView); item.reason = SensitiveArtifactRedactor.safe(item.reason);
        }
        const metadata = result.operations;
        if (metadata === null) return;
        metadata.appSite = SensitiveArtifactRedactor.safe(metadata.appSite); metadata.appFile = SensitiveArtifactRedactor.safe(metadata.appFile);
        metadata.appView = SensitiveArtifactRedactor.safe(metadata.appView); metadata.templateName = SensitiveArtifactRedactor.safe(metadata.templateName);
        for (const operation of metadata.operations) SensitiveArtifactRedactor.redactOperation(operation);
        for (const item of metadata.inheritanceOperations) {
            item.targetTemplate = SensitiveArtifactRedactor.safe(item.targetTemplate);
            item.contextPath = item.contextPath.map(SensitiveArtifactRedactor.safe);
            item.inheritKey = SensitiveArtifactRedactor.safe(item.inheritKey); item.sourceTemplate = SensitiveArtifactRedactor.safe(item.sourceTemplate);
            item.defaultValue = SensitiveArtifactRedactor.safe(item.defaultValue); item.resolvedValue = SensitiveArtifactRedactor.safe(item.resolvedValue);
        }
    }

    private static redactOperation(operation: TemplateOperation): void {
        operation.templateName = SensitiveDataRedactor.redactText(operation.templateName);
        operation.target = SensitiveDataRedactor.redactText(operation.target);
        operation.replacedWith = SensitiveDataRedactor.redactText(operation.replacedWith);
        operation.paramJson = SensitiveDataRedactor.redactText(operation.paramJson);
        for (const nested of operation.operations) SensitiveArtifactRedactor.redactOperation(nested);
    }

    private static safe(value: string): string {
        const redacted = SensitiveDataRedactor.redactText(value);
        return redacted;
    }
}
